<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Pro Added'"
      [canGoBack]="false" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-row [align]="'center'" class="extra-bottom-padding">
        <tidy-text
          [body]="'Would you like to send a job request to'" /><span>&nbsp;</span>
          <tidy-text
            [body]="pro?.first_name + '?'" /><span>&nbsp;</span>
            <tidy-text
              [body]="'They can use the app to accept.'" />
          </tidy-row>

          <tidy-row>
            <tidy-button
              [text]="'Send Job Request'"
              [action]="boundSendJobRequest"
              class="primary full-width" />
          </tidy-row>

          <tidy-row>
            <tidy-button
              [text]="'Go to My Pros'"
              [action]="boundGoToMyPros"
              class="secondary full-width" />
          </tidy-row>
        </tidy-card>
      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }